import { middleware as loginMiddleware, reducers as loginReducers } from '@local/login';
import type { Reducer } from '@reduxjs/toolkit';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';

import { imagoMpApi } from 'src/apiClients';

const combinedReducer = combineReducers({
    ...loginReducers,
    [imagoMpApi.reducerPath]: imagoMpApi.reducer,
});

const rootReducer: Reducer<RootState> = (state, action) => {
    if (action.type === 'store/reset') {
        return {} as RootState;
    }
    return combinedReducer(state, action);
};

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat([...loginMiddleware])
            .concat(imagoMpApi.middleware),
});

// Infer the `RootState` from combinedReducer
export type RootState = ReturnType<typeof combinedReducer>;
// Infer the `AppDispatch` type from the store itself
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => typeof store.dispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
